import { VFC } from "react";
import { Game, GameStatus } from "../../../../utils/Game";
import { Card } from "antd";
import { InventedNameModal } from "./InventedNameModal";
import { ActivePlayerAnzeige } from "../ActivePlayerAnzeige/ActivePlayerAnzeige";
import { QuestionButton } from "../../../QuestionButton";

export const GameMember: VFC<{ game?: Game; small: boolean }> = ({
  game,
  small,
}) => {
  switch (game?.status) {
    case GameStatus.WAIT_FOR_MEMBERS:
      return (
        <Card
          size={small ? "small" : undefined}
          title={small ? undefined : "Wartet auf den Spielstart"}
          extra={small ? undefined : <QuestionButton />}
        >
          Der Spielleiter muss das Spiel starten, wenn alle da sind.
        </Card>
      );

    case GameStatus.WAIT_FOR_INVENTED_NAME:
      return (
        <>
          <InventedNameModal />
          <Card
            size={small ? "small" : undefined}
            title={small ? undefined : "Spielern Namen zuordnen"}
            extra={small ? undefined : <QuestionButton />}
          >
            Wir müssen warten bis jedem Spieler ein Name zugewiesen worden ist,
            der Spielleiter wird das Spiel dann starten.
          </Card>
        </>
      );

    case GameStatus.PLAY:
      return <ActivePlayerAnzeige small={small} />;

    default:
      return null;
  }
};
